// store/features/reducers/createCompetitorReducer.js
import {
  CREATE_COMPETITOR_REQUEST,
  CREATE_COMPETITOR_SUCCESS,
  CREATE_COMPETITOR_FAILURE,
} from "../actions/createCompetitorActions";

const initialState = {
  creating: false,
  success: false,
  error: null,
  status: null,
};

export default function createCompetitorReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_COMPETITOR_REQUEST:
      return {
        ...state,
        creating: true,
        success: false,
        error: null,
        status: null,
      };
    case CREATE_COMPETITOR_SUCCESS:
      return {
        ...state,
        creating: false,
        success: true,
        error: null,
        status: action.payload,
      };
    case CREATE_COMPETITOR_FAILURE:
      return {
        ...state,
        creating: false,
        success: false,
        error: action.payload,
        status: null,
      };
    default:
      return state;
  }
}
